<template>
    <div class="tools-item-container" @click="toOhterSite">
        <div class="img-box">
            <img :src="toolsItem.image" alt="">
        </div>
        <div class="content-box">
            <div class="content-title">{{ toolsItem.name }}</div>
            <div class="content-content">{{ toolsItem.description }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            toolsItem:{
                type:Object,
                default:()=>{}
            }
        },
        data() {
            return {}
        },
        methods:{
            toOhterSite() {
                this.$emit('toOhterSite',this.toolsItem)
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/styles/mixin.less";
    @import "~@/styles/var.less";
    .tools-item-container {
        height: 84px;
        width: 246px;
        border-radius: 10px;
        display: flex;
    }
    .tools-item-container:hover {
        background-color: #F9F9F9;
        cursor: pointer;
    }
    .tools-item-container:not(:last-child) {
        margin-right: 4px;
    }
    .img-box {
        width: 50px;
        height: 50px;
        background: #D8D8D8;
        border-radius: 8px;
        margin:11px 17px 23px 11px;
        overflow: hidden;
        >img {
            width: 100%;
            height:100%;
            object-fit: cover;
        }
    }
    .content-box {
        width: 160px;
        padding-top: 14px;
        padding-right: 8px;
        box-sizing: border-box;
    }
    .content-title {
        font-size: 14px;
        font-weight: 600;
        color: @words;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .content-content {
        font-size: 12px;
        font-weight: 400;
        color: @tipwords;
        margin-top:5px;
        .line-clamp()
    }
</style>